import PasswordEdit from '@/components/Profile/PasswordEdit';
import React, { createContext, useCallback, useContext, useState } from 'react';

interface IPasswordModalContext {
  openPasswordModal: () => void;
  closePasswordModal: () => void;
}

const PasswordModalContext = createContext<IPasswordModalContext | undefined>(undefined);

interface IPasswordModalProviderProps {
  children: React.ReactNode;
}

export const PasswordModalProvider: React.FC<IPasswordModalProviderProps> = ({ children }) => {
  const [open, setOpen] = useState<boolean>(false);

  const openPasswordModal = useCallback(() => {
    setOpen(true);
  }, []);

  const closePasswordModal = useCallback(() => {
    setOpen(false);
  }, []);

  return (
    <PasswordModalContext.Provider
      value={{
        openPasswordModal,
        closePasswordModal,
      }}
    >
      {children}

      {/* Modal global */}
      <PasswordEdit
        open={open}
        onClose={closePasswordModal}
      />
    </PasswordModalContext.Provider>
  );
};

export const usePasswordModal = (): IPasswordModalContext => {
  const context = useContext(PasswordModalContext);

  if (!context) {
    throw new Error('usePasswordModal must be used within PasswordModalProvider');
  }

  return context;
};